import Colors from '@/Colors';

// eslint-disable-file max-len
export default class MapUnitClusterControl {
  private mapInternal: any;

  private containerInternal: any;

  private btn: any;

  private iconActiveStyle: string;

  private iconInactiveStyle: string;

  private buttonActiveStyle: string;

  private buttonInactiveStyle: string;

  public clickHandler: any;

  public id: string;

  onAdd(map) {
    this.mapInternal = map;
    this.containerInternal = window.document.createElement('div');
    this.containerInternal.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    const iconStyle = 'width: 20px; height: 20px;margin-top: 4px;';
    this.iconActiveStyle = `${iconStyle} stroke: ${Colors.primaryReverse}`;
    this.iconInactiveStyle = `${iconStyle} stroke: #58595B`;
    this.buttonInactiveStyle = '';
    this.buttonActiveStyle = `background-color: ${Colors.primary}`;

    this.btn = window.document.createElement('button');
    this.btn.className = 'mapboxgl-ctrl-icon';
    this.btn.title = 'Toggle screens';
    this.btn.id = this.id;
    this.btn.onclick = () => {
      if (this.clickHandler !== undefined) {
        this.clickHandler();
      }
    };

    this.btn.innerHTML =
      '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px"' +
      'height="24px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve"> ' +
      '<g id="Black"> ' +
      '<g> ' +
      '<rect x="0.5" y="3.5" fill="none"  stroke-linejoin="round" stroke-miterlimit="10" width="22" height="16"/> ' +
      '<line fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="19.5" y1="17.5" x2="20.5" y2="17.5"/> ' +
      '<line fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="11.5" y1="19.5" x2="11.5" y2="23.5"/> ' +
      '<line fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" x1="5.5" y1="23.5" x2="17.5" y2="23.5"/> ' +
      '</g> ' +
      '</g> ' +
      '</svg>';
    this.btn.firstChild.style = this.iconInactiveStyle;
    this.containerInternal.appendChild(this.btn);
    return this.containerInternal;
  }

  onRemove() {
    this.containerInternal.parentNode.removeChild(this.containerInternal);
    this.mapInternal = undefined;
  }

  setActiveClasses() {
    this.btn.style = this.buttonActiveStyle;
    this.btn.firstChild.style = this.iconActiveStyle;
  }

  setInactiveClasses() {
    this.btn.style = this.buttonInactiveStyle;
    this.btn.firstChild.style = this.iconInactiveStyle;
  }
}
